import * as React from "react";
import { cn } from "@/lib/utils";

export function Panel({ className, ...rest }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("gm-panel p-4", className)} {...rest} />;
}

export function PanelHeader({ className, ...rest }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("mb-4 flex items-center justify-between gap-4", className)} {...rest} />;
}

export function PageTitle({ className, ...rest }: React.HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h1
      className={cn(
        "font-display text-2xl font-bold tracking-tight text-[#e2e8f0]",
        className,
      )}
      {...rest}
    />
  );
}
